import PropTypes from "prop-types";
import "@css/Loader.css";


const ErrorComponent = ({ title = "Ошибка", message = "Что-то пошло не так." }) => {
    return (
        <div className="full-page-loader">
            <div className="loader-content">
                <div className="error-icon" aria-hidden>!</div>
                <p className="loader-text" role="alert">
                    {title || "Ошибка"}
                </p>
                <div className="error-card">
                    <div className="error-header">
                        <span className="error-title">
                            {message}
                        </span>
                        <div className="error-actions">
                            <button
                                type="button"
                                className="error-btn secondary"
                                onClick={() => globalThis.location.reload()}
                            >
                                Обновить страницу
                            </button>
                            <button
                                type="button"
                                className="error-btn secondary"
                                onClick={ () => globalThis.location.href = '/' }
                            >
                                На главную
                            </button>
                        </div>
                    </div>
                
                </div>
            </div>
        </div>
    );
};

ErrorComponent.propTypes = {
    title: PropTypes.string,
    message: PropTypes.node,
};

export default ErrorComponent;
